'use client'

import {
  CheckCircleIcon,
  ShoppingBagIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline'
import { Button } from '@/General/Button'
import { Modal } from '@/Modal'
import { formatDate } from '@/date'
import { isPreorderReleaseTodayOrFuture } from '@/lib/formatProductType'

export const AddedToCartModal = ({
  isOpen,
  productName,
  onClose,
  isPreorder = false,
  preorderReleaseDate = null,
  notice = null,
}: AddedToCartModalProps) => {
  const releaseDateText =
    preorderReleaseDate && isPreorderReleaseTodayOrFuture(preorderReleaseDate)
      ? formatDate(preorderReleaseDate)
      : null

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative">
        <div className="relative bg-gradient-to-br from-green-50 to-emerald-50 px-6 pt-8 pb-6 overflow-hidden">
          <div className="flex flex-col items-center">
            <div
              className={`w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 transform scale-100 opacity-100`}
            >
              <CheckCircleIcon className="w-8 h-8 text-white" />
            </div>
            <div className="mt-4 text-center transition-all duration-200 opacity-100">
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                Added to Cart!
              </h3>
              <p className="text-green-700 font-medium">{productName}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 py-6 space-y-3">
        {isPreorder && (
          <p className="text-gray-600">
            {releaseDateText ? (
              <>
                The estimated launch date for this pre-order is{' '}
                {releaseDateText}. If your order contains other items, they will
                all be shipped together. You may consider placing a separate
                order for in-stock items if you want them sooner.
              </>
            ) : (
              <>
                As this is a pre-order, if your order contains other items, they
                will all be shipped together. You may consider placing a
                separate order for in-stock items if you want them sooner.
              </>
            )}
          </p>
        )}
        {notice ? (
          <p className="text-gray-700 text-base leading-relaxed">{notice}</p>
        ) : null}
        {!isPreorder ? (
          <p className="text-gray-900 text-lg font-medium leading-snug">
            Where would you like to go now?
          </p>
        ) : null}
        <Button href="/checkout" className="w-full">
          <ShoppingBagIcon className="w-5 h-5 mr-2 group-hover:animate-bounce" />
          Go to checkout
          <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
        </Button>
        <Button onClick={onClose} color="gray" className="w-full">
          Continue shopping
        </Button>
      </div>
    </Modal>
  )
}

interface AddedToCartModalProps {
  isOpen: boolean
  productName: string
  onClose: () => void
  isPreorder?: boolean
  preorderReleaseDate?: string | null
  /** Partial parent/child bundle add (legacy AjaxAdd extraText). */
  notice?: string | null
}
